export enum BalanceState {
  NEW = 'new',
  BALANCING = 'balancing',
  READY = 'ready',
  EXPORTING = 'exporting',
  ERROR = 'error',
}
